import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FabricChannel } from '../types';
import processEvent from './process-event';
import GenericAnalyticsListener from '../GenericAnalyticsListener';
export default function AVPAnalyticsListener(props) {
  return /*#__PURE__*/React.createElement(GenericAnalyticsListener, _extends({}, props, {
    channel: FabricChannel.avp,
    processEvent: processEvent
  }));
}